import { Injectable } from "@angular/core";
import { FormulaDefinitionService } from "@module-definition/formulas/cipo-formula-definition/cipo-formula-definition.service";

@Injectable({
  providedIn: 'root',
})
export class DemoFormulasService extends FormulaDefinitionService {
  
}